import { ItemAdjustments } from '@app/cart/services/voucher-adjustments/data';
import { VoucherItemAdjustment, VoucherQualifier } from '@app/cart/services/voucher-qualifiers/data';

type AdjustFunction = (item: ItemAdjustments, value: number) => number;

const adjust = (adjustFn: AdjustFunction) => (item: ItemAdjustments, value: number): ItemAdjustments => {
    const clone = item.clone();
    clone.adjustment = adjustFn(item, value);
    return clone;
};

const ensureNotGreaterThanPrice = (adjustment: number, price: number) => ((price + adjustment) < 0) ? -price : adjustment;

export const percentAdjust = adjust((item, value) => ensureNotGreaterThanPrice(
    item.adjustment + ((item.price * value) / 100),
    item.price
));

export const dollarAdjust = adjust((item, value) => ensureNotGreaterThanPrice(
    item.adjustment + value,
    item.price)
);

export const noopAdjust = adjust((item, value) => item.adjustment);

export const applyAdjustmentOfVoucherQualifier = (item: ItemAdjustments, qualifiers: VoucherItemAdjustment[]) =>
    qualifiers.reduce((result, qualifier) => {
        const modifierType = qualifier.modifierType;
        const value = qualifier.value;
        switch (modifierType) {
        case '%_ADJUSTMENT':
            return percentAdjust(result, value);
        case '$_ADJUSTMENT':
            return dollarAdjust(result, value);
        default:
            return noopAdjust(result, value);
        }

    }, item.clone());
